// hooks
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// import components
import Col from "react-bootstrap/Col";

//import sample data
import menuItems from "../../utils/data/menuItems";

// import assets
import itemIcon from "../../assets/img/yallalodo.png";

const List = () => {
    const [hide, setHide] = useState(true);
    const [currList, setCurrList] = useState(menuItems);
    const [prevLists, setPrevLists] = useState([]);

    const [t] = useTranslation("global");
    // set the current list items
    // const makePrevList = () => setPrevLists([...prevLists, currList]);

    const makeNextList = (item) => {
        const nextList = item.subItems;
        if (nextList.length) {
            // makePrevList();
            setPrevLists([...prevLists, currList]);
            setCurrList(nextList);
        }
    };

    const fallBack = () => {
        const prevList = prevLists[prevLists.length - 1];
        let tempPrevLists = prevLists;
        tempPrevLists.pop();
        setPrevLists(tempPrevLists);
        setCurrList(prevList);
    };

    const resetList = () => {
        setCurrList(menuItems);
        setPrevLists([]);
        setHide(true);
    };

    useEffect(() => {
        console.log("use effeect");
        console.log(`length: ${prevLists.length}`);
        console.log(prevLists);
        console.log("done");
    }, [prevLists]);
    return (
        <Col className="nav-products-row" onMouseLeave={() => setHide(true)}>
            <div className="menu-svg" onClick={() => setHide(!hide)}></div>
            <div
                className={`sm-list${hide ? " hide" : ""}`}
                onMouseLeave={() => setHide(true)}
            >
                <div className="overlay-nav-div"></div>
                <ul className="sm-nav-ul">
                    <>
                        {prevLists.length ? (
                            <div
                                className="sm-title-item return-nav-btn"
                                onClick={() => fallBack()}
                            >
                                <div className="nav-btn">
                                    <div className="arrow-svg "></div>
                                    <p>{t("nav.list.return")}</p>
                                </div>

                                <div
                                    className="closeSvg"
                                    onClick={() => resetList()}
                                ></div>
                            </div>
                        ) : (
                            <div className="sm-title-item return-nav-btn">
                                <div className="products-btn nav-btn">
                                    <div className="products-svg"></div>
                                    <p>{t("nav.list.products")}</p>
                                </div>
                                <div
                                    className="closeSvg"
                                    onClick={() => resetList()}
                                ></div>
                            </div>
                        )}
                    </>
                    {currList.map((i) => {
                        return (
                            <li
                                key={i.title}
                                className="sm-item"
                                onClick={() => makeNextList(i)}
                            >
                                <div className="list-item-title">
                                    <div className="list-img-text">
                                        <img src={itemIcon} alt={i.title} />
                                        <p> {i.title}</p>
                                    </div>
                                    {i.subItems.length ? (
                                        <div className="arrow-svg"></div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </Col>
    );
};

export default List;
